import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CommonService} from 'src/app/shared/utils/common.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloVMI} from '../../diccionarios/moduloVMI';

@Injectable({
  providedIn: 'root'
})
export class VmiOrdeneService {

  diccionarioUrl: any = {};
  url: string;

  constructor(
    private _commom: CommonService,
    private _utils: UtilsService
  ) {
    this.url = this._utils.getVmi();
    this.diccionarioUrl = moduloVMI.url.informes;
  }

  getPedidoFecha(desde: string, hasta: string): Observable<any[]> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.ordenesFecha + `/${desde}/${hasta}`);
  }

  getDocFactura(token: string): Observable<any[]> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.factura + `/${token}`);
  }

}